import { uniq } from 'lodash'

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function ContentTypeFormatter({ info }) {
  const { value, row } = getInfo(info)
  const { files } = row.meta || {}

  if (files) {
    return uniq(files.map(({ content_type }) => content_type).filter(Boolean)).join(', ') || 'N/A'
  }

  return value
}
